import React from "react";

import { ListItemText as MUIListItemText } from "@mui/material";

const ListItemText = ({ item }) => {
  const title = `${item.productCode}  -  ${item.title}`
  const secondary = `${item.description} \t ${item.price}`

  return (
    <MUIListItemText
      primary={title || "null" }
      secondary={secondary || "null" }
    />
  );
};

export default ListItemText;